export enum DocumentType {
  Article = 'article',
  BrandConfiguration = 'brandConfiguration',
  BrandNavigation = 'brandNavigation',
  Category = 'category',
  CommonSocialFeed = 'commonSocialFeed',
  Dashboard = 'dashboardPage',
  Event = 'eventArticle',
  Form = 'form',
  Interactions = 'interactions',
  ModuleArticle = 'moduleArticle',
  OrderArticle = 'orderArticle',
  OrderCategory = 'orderCategory',
  OrderConfiguration = 'orderConfiguration',
  Person = 'person',
  ServiceArticle = 'serviceArticle',
  SimpleCategory = 'simpleCategory',
  SocialFeed = 'socialFeed',
  SocialFeedPost = 'socialFeedPost',
  Subject = 'subject',
  SubjectArticle = 'subjectArticle',
  SubjectEvent = 'subjectEvent',
  SubjectFrontpage = 'subjectFrontpage',
  SubjectTopicPage = 'subjectTopicPage',
  Tag = 'tag',
  TopicPage = 'topicPage',
}
